<template>
  <footer>
    <template v-if="!isLocationLanding">
      <div class="contact">
        <p>Adress {{ locationData.address }}</p>
        <p>Telefon <a :href="`tel:${locationData.phoneLink}`">{{ locationData.phone }}</a></p>
        <p>E-post <a :href="`mailto:${locationData.email}`">{{ locationData.email }}</a></p>
      </div>
    </template>

    <div class="location-switcher">
      <p class="switch-label">Byt till:</p>
      <router-link :to="switcherData.link" class="location-switch">{{ switcherData.name }}</router-link>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',

    computed: {
      location () {
        return this.$route.params.location || this.$route?.meta?.location;
      },
      isLocationLanding () {
        return ['haga-norra-landing', 'enskede-landing', 'slaktis-landing'].includes(this.$route.name);
      },
      switcherData () {
        if (this.location === 'haga-norra') {
          return {
            link: '/slaktis',
            name: 'Ateljéns Pizza Slaktis'
          };
        }
        if (this.location === 'slaktis') {
          return {
            link: '/enskede',
            name: 'Ateljéns Pizza Enskede'
          };
        }
        return {
          link: '/haga-norra',
          name: 'Ateljéns Pizza Haga Norra'
        };
      },
      locationData () {
        const locations = {
          'enskede': {
            address: 'Nynäsvägen 320 122 34 Enskede',
            phone: '08 409 198 11',
            phoneLink: '+46840919811',
            email: 'kontakt@ateljenspizza.se'
          },
          'haga-norra': {
            address: 'Mathildatorget 1 16975 Solna',
            phone: '073-771 44 80',
            phoneLink: '+46737714480',
            email: 'haganorra@ateljenspizza.se'
          },
          'slaktis': {
            address: 'Hallvägen 9 121 62 Johanneshov',
            phone: '08 409 198 11',
            phoneLink: '+46840919811',
            email: 'slaktis@ateljenspizza.se'
          }
        };
        return locations[this.location] || locations['enskede'];
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/helpers'
  @require '~global/breakpoints'

  footer
    @extend .flex-vh
    flex-direction: column
    padding: 3rem $default-padding
    text-align: center

  .contact
    display: flex
    flex-direction: column
    gap: 0.25rem

    p
      margin: 0.125rem 0
      text-transform: uppercase

  a
    text-decoration: none
    color: inherit

    &:hover
      color: $red

  .location-switcher
    display: flex
    flex-direction: column
    gap: 0.25rem
    margin-top: 2rem

    .switch-label
      margin: 0.125rem 0
      text-transform: uppercase

    .location-switch
      text-decoration: underline
      text-transform: uppercase
      color: $off-black-lighter

      &:hover
        color: $red
</style>
